import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ChildPriceDropdown,
  CopyToOtherUser,
  CreateClientPrice,
  CustomerPriceListing,
  DeleteClientPriceList,
  GetLanguages,
  GetOneClientPrice,
  JobSummeryResource,
  MasterPriceListDropdown,
  SpecializationDropdown,
  UpdateClientPrice,
} from "../../../../redux/Thunk/ClientModule/ClientThunk";
import {
  Autocomplete,
  Box,
  Chip,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import Btn from "../../../../Components/Ui_elements/Btn";
import TextFieldComponent from "../../../../Components/TextFieldComponent";
import DropdownComponent from "../../../../Components/DropdownComponent";
import { CurrencyCode } from "../../../../redux/Thunk/AdminModule/AdminThunk";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useParams } from "react-router-dom";
import GenericTable from "../../../../Components/Ui_elements/GenericTable";
import { SortAlphabetically } from "../../../../Helper/SortAlphbetically";
import PopupModal from "../../../../Components/Ui_elements/PopupModal";
import { getSingleExternalResource } from "../../../../redux/Thunk/externalResourceThunk";
import { getRateFromPriceBasis, isValidNumber, localizeNumber, normalizeNumber } from "../../../../Helper/generalhelper";
import MultiSelect from "../../../../Components/MultiSelect";
import DropdownWithSelectedList from "../../../../Components/DropdownWithSelectedList";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const Step3 = ({ registerSubmit }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const cId = searchParams.get("c_id");

  const {
    specialization_list,
    master_price_list,
    child_price_list,
    languages_dropdown_list,
    customer_price_list,
    single_price_data,
    job_summery_resource,
  } = useSelector(state => state.root.ClientModule);
  const { currencyCode } = useSelector(state => state.root.AdminModule);
  const { externalResource, new_external_created, edit_external_resource_data } = useSelector(
    state => state.root.ExternalResource
  );

  const externalResourceArray = [externalResource];
  const filteredArray = externalResourceArray?.filter(item => item !== null); // Remove null values

  const userName = filteredArray?.find(item => item?.iUserId == id)
    ? `${filteredArray.find(item => item?.iUserId == id)?.vFirstName || ""} ${filteredArray.find(item => item?.iUserId == id)?.vLastName || ""}`.trim()
    : new_external_created?.userData
      ? `${new_external_created.userData?.vFirstName || ""} ${new_external_created.userData?.vLastName || ""}`.trim()
      : edit_external_resource_data?.data
        ? `${edit_external_resource_data.data?.vFirstName || ""} ${edit_external_resource_data.data?.vLastName || ""}`.trim()
        : "";

  const freelancerCurrencyCode = filteredArray?.find(item => item?.iUserId == id)?.currency_code ?? "EUR";

  useEffect(() => {
    if (id) {
      dispatch(getSingleExternalResource({ user_id: id }));
    }
    dispatch(SpecializationDropdown());
    dispatch(MasterPriceListDropdown());
    dispatch(ChildPriceDropdown());
    dispatch(GetLanguages());
    dispatch(CurrencyCode());
    dispatch(CustomerPriceListing(2));
    dispatch(JobSummeryResource());
  }, [dispatch]);

  const [show, setShow] = useState(false);
  const [languageRows, setLanguageRows] = useState([]);
  const [languageRowsShort, setLanguageRowsShort] = useState([]);
  const [priceRows, setPriceRows] = useState([]);
  const [selectedPrices, setSelectedPrices] = useState([]);
  const [openForDelete, setOpenForDelete] = useState(false);
  const [copyOpen, setCopyOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [edit, setEdit] = useState(false);
  const priceRowsRef = useRef(priceRows);

  const [formData, setFormData] = useState({
    price_name: `${userName} | `,
    price_currency: "",
    min_price_item: "",
    specialization: [],
    source_lang: "",
    target_lang: "",
    basePriceType: "",
  });
  const [copyToClient, setCopyToClient] = useState({
    client_id: "",
  });
  useEffect(() => {
    priceRowsRef.current = priceRows;
  }, [priceRows]);

  useEffect(() => {
    if (userName && !edit) {
      // Only update if not in edit mode
      setFormData(prevData => ({
        ...prevData,
        price_name: `${userName} | `,
      }));
    }
  }, [userName, edit]);

  useEffect(() => {
    if (!single_price_data || !edit || !freelancerCurrencyCode) return;

    const {
      price_name,
      min_price_item,
      price_currency,
      specialization,
      price_language,
      price_basis,
    } = single_price_data;

    // ✅ SAFE parsing
    const parsedPriceLanguage = price_language
      ? JSON.parse(price_language)
      : [];

    const parsedPriceBasis = price_basis
      ? JSON.parse(price_basis)
      : [];

    setFormData({
      price_name,
      price_currency: freelancerCurrencyCode,
      //price_currency: price_currency.split(",")[0],
      min_price_item,
      specialization: specialization ? specialization.split(",") : [],
      source_lang: "",
      target_lang: "",
      basePriceType: "",
    });

    // Languages
    const languageRows = parsedPriceLanguage.map(lang => lang.languagePrice);
    setLanguageRows(languageRows);

    const languageRowsShort = languageRows.map(lang => {
      const [source, target] = lang.split(" > ");
      return `${source?.substring(0, 3).toUpperCase()} > ${target
        ?.substring(0, 3)
        .toUpperCase()}`;
    });
    setLanguageRowsShort(languageRowsShort);

    // Prices
    const priceRows = parsedPriceBasis.map(price => {
      const total =
        normalizeNumber(localizeNumber(price.baseQuentity)) *
        normalizeNumber(localizeNumber(price.basePrice));

      return {
        quantity: localizeNumber(price.baseQuentity),
        priceUnit: price.basePriceUnit,
        prices: localizeNumber(price.basePrice),
        weighting: 1.0,
        total: localizeNumber(total),
        childPriceId: price.childPriceId,
        masterPriceId: price.masterPriceId,
      };
    });

    setPriceRows(priceRows);
  }, [single_price_data, edit, freelancerCurrencyCode]);


  const sourceLangCode = formData.source_lang?.substring(0, 3).toUpperCase() || "";
  const targetLangCode = formData.target_lang?.substring(0, 3).toUpperCase() || "";

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));

    setCopyToClient(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeLanguage = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleChange = (event, newValue) => {
    const selectedMasterIds = newValue
      .filter(item => item.type === "master")
      .map(item => item.master_price_id);

    const updatedSelection = newValue.flatMap(item => {
      if (item.type === "master") {
        return [
          item,
          ...child_price_list.filter(child => child.master_price_id === item.master_price_id),
        ];
      }
      return item;
    });

    const filteredSelection = updatedSelection.filter(item => {
      if (item.type === "child") {
        return selectedMasterIds.includes(item.master_price_id);
      }
      return true;
    });

    setSelectedPrices(filteredSelection);
  };

  const handleAddLanguageRow = () => {
    if (!formData.source_lang?.trim()) {
      setError(prev => ({
        ...prev,
        source_lang: "Source language is required",
      }));
    }
    if (!formData.target_lang?.trim()) {
      setError(prev => ({
        ...prev,
        target_lang: "Target language is required",
      }));
    }
    if (!formData.source_lang || !formData.target_lang) return;

    const newLanguagePair = `${sourceLangCode} > ${targetLangCode}`;
    setLanguageRowsShort(prev => [...prev, newLanguagePair]);
    setLanguageRows(prev => [...prev, `${formData.source_lang} > ${formData.target_lang}`]);

    // Fix: Only add language pairs if there are any
    const languagePart =
      [...languageRowsShort, newLanguagePair].length > 0
        ? ` | ${[...languageRowsShort, newLanguagePair].join(" | ")} |`
        : "";

    setFormData(prevData => ({
      ...prevData,
      price_name: `${prevData.price_name.split("|")[0].trim()}${languagePart}`,
    }));

    setFormData(prevData => ({
      ...prevData,
      source_lang: "",
      target_lang: "",
    }));

    setError(prev => {
      const newErr = { ...prev };
      delete newErr.languageRows;
      return newErr;
    });
  };

  const handleAddPriceRow = () => {
    if (selectedPrices.length === 0) {
      setError(prev => ({
        ...prev,
        selectedPrices: "Please select at least one price",
      }));
      return;
    }
    const newRows = selectedPrices
      .filter(selectedPrice => {
        // Check if the priceUnit already exists in the priceRows
        return !priceRows.some(row => row.priceUnit === selectedPrice.name);
      })
      .map(selectedPrice => ({
        quantity: 1, // Default quantity
        priceUnit: selectedPrice.name, // Use the selected price name
        prices: 1.0, // Default price
        weighting: 1.0, // Default weighting
        total: 1.0, // Default total
        childPriceId: selectedPrice.child_price_id,
        masterPriceId: selectedPrice.master_price_id,
      }));

    setPriceRows(prev => [...prev, ...newRows]);
    setSelectedPrices([]); // Clear the selected prices after adding rows

    setError(prev => {
      const newErr = { ...prev };
      delete newErr.priceRows;
      return newErr;
    });
  };

  const handleMultiSelectChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: typeof value === "string" ? value.split(",") : value,
    }));
    if (value && (typeof value === "string" ? value.trim() : value.length > 0)) {
      setError(prev => {
        const newErr = { ...prev };
        delete newErr[name];
        return newErr;
      });
    }
  };

  const handleChipDelete = valueToRemove => {
    setFormData(prev => ({
      ...prev,
      specialization: prev.specialization.filter(item => item !== valueToRemove),
    }));
  };

  const handleDelete = index => {
    const updatedLanguageRows = languageRows.filter((_, i) => i !== index);
    setLanguageRows(updatedLanguageRows);
    const updatedLanguageRowsShort = languageRowsShort.filter((_, i) => i !== index);
    setLanguageRowsShort(updatedLanguageRowsShort);

    // Fix: Only add language pairs if there are any
    const languagePart =
      updatedLanguageRowsShort.length > 0 ? ` | ${updatedLanguageRowsShort.join(" | ")} |` : "";

    setFormData(prevData => ({
      ...prevData,
      price_name: `${prevData.price_name.split("|")[0].trim()}${languagePart}`,
    }));
  };

  const handleDeletePriceRow = index => {
    const updatedPriceRows = priceRows.filter((_, i) => i !== index);
    setPriceRows(updatedPriceRows);
  };

  const handleQuantityChange = (index, value) => {
    const updatedPriceRows = [...priceRows];
    const total = normalizeNumber(value) * normalizeNumber(updatedPriceRows[index].prices);

    updatedPriceRows[index].quantity = value;
    updatedPriceRows[index].total = localizeNumber(total);
    setPriceRows(updatedPriceRows);
  };

  const handlePriceChange = (index, value) => {
    const updatedPriceRows = [...priceRows];
    const total = normalizeNumber(value) * normalizeNumber(updatedPriceRows[index].quantity);

    updatedPriceRows[index].prices = value;
    updatedPriceRows[index].total = localizeNumber(total);
    setPriceRows(updatedPriceRows);
  };
  const [edited, setEdited] = useState(false);
  const [error, setError] = useState({});
  const handleSave = () => {
    setShow(true);
    setEdited(false);
    const newErrors = {};

    if (!formData.price_name?.trim()) {
      newErrors.price_name = "Name is required";
    }
    if (!formData.specialization?.length) {
      newErrors.specialization = "Specialization is required";
    }

    if (!formData.price_currency?.trim()) {
      newErrors.price_currency = "Currency is required";
    }

    // if (!formData.min_price_item?.toString().trim()) {
    //   newErrors.min_price_item = "Min price item is required";
    // }

    if (languageRows.length === 0) {
      newErrors.languageRows = "At least one language pair is required";
    }

    if (priceRows.length === 0) {
      newErrors.priceRows = "At least one price is required";
    }

    setError(prevError => ({
      ...prevError,
      ...newErrors,
    }));

    if (Object.keys(newErrors).length > 0) {
      return; // stop here if there are validation errors
    }

    const priceBasisArray = priceRowsRef.current?.map(row => ({
      baseQuentity: normalizeNumber(row.quantity),
      basePricecheck: 1,
      basePriceUnit: row.priceUnit,
      basePrice: normalizeNumber(row.prices),
      standardTime: "",
      childPriceId: row.childPriceId,
      masterPriceId: row.masterPriceId,
    }));

    const payload = {
      price_name: formData.price_name,
      //price_currency: `${formData.price_currency},${currencyCode[formData.price_currency]?.symbol}`,
      price_currency: `${formData.price_currency},${currencyCode[formData.price_currency]?.symbol}`,
      min_price_item: formData.min_price_item,
      specialization: formData.specialization.join(","),
      price_language: JSON.stringify(languageRows.map(lang => ({ languagePrice: lang }))),
      price_basis: JSON.stringify(priceBasisArray), // Use the properly constructed array
      price_id: 2, // 1 static for the client and 2 for resource
      resource_id: id || new_external_created?.iUserId, // Assuming the resource_id is the client ID
    };

    // Add price_list_id only if it's an edit operation
    if (edit && single_price_data?.price_list_id) {
      payload.price_list_id = single_price_data.price_list_id;
    }

    const action = edit ? UpdateClientPrice : CreateClientPrice;

    dispatch(action(payload)).then(() => {
      dispatch(CustomerPriceListing(2));
      setShow(false);

      // Reset form data but keep the username in the price_name field
      setFormData({
        price_name: `${userName} | `, // Preserve the username
        price_currency: "",
        min_price_item: "",
        specialization: [],
        source_lang: "",
        target_lang: "",
        basePriceType: "",
      });
      setError({});
      setLanguageRows([]);
      setLanguageRowsShort([]);
      setPriceRows([]);
      setEdit(false);
    });
    return true;
  };

  const options = master_price_list?.flatMap(master => [
    { type: "master", ...master },
    ...child_price_list.filter(child => child?.master_price_id === master?.master_price_id),
  ]);

  const currencyOptions = Object.entries(currencyCode)?.map(([key, currency]) => ({
    label: `${key}`,
    value: key,
  }));

  const specializationOptions = specialization_list?.map(item => ({
    label: item.name,
    value: item.id,
  }));

  const languageOptions = languages_dropdown_list?.map(item => ({
    label: item.title,
    value: item.title,
  }));

  const jobResourceOptions = job_summery_resource?.map(resource => ({
    value: resource.iUserId,
    label: `${resource.vUserName}`,
  }));
  const resourceId = id ? id : cId;
  const TableList = customer_price_list?.filter(item => item?.resource_id == resourceId);

  const columns = [
    {
      name: "rowNumber",
      label: "No.",
      options: {
        sort: true,
        setCellHeaderProps: () => ({ style: { width: "50px" } }),
        setCellProps: () => ({ style: { width: "40px" } }),
      },
    },
    { name: "price_list_id", label: "ID", options: { display: false } },
    {
      name: "price_name",
      label: "Name",
      options: {
        setCellHeaderProps: () => ({ style: { width: "200px" } }),
        setCellProps: () => ({ style: { width: "200px" } }),
      },
    },
    // {
    //   name: "price_basis",
    //   label: "New Word Rate",
    //   options: {
    //     filter: false,
    //     customBodyRender: value =>
    //       getRateFromPriceBasis(value, "Words Translation (New)"),
    //   },
    // },
    // {
    //   name: "price_basis",
    //   label: "Hourly Proofreading Rate",
    //   options: {
    //     filter: false,
    //     customBodyRender: value =>
    //       getRateFromPriceBasis(value, "Hour(s) Proofreading"),
    //   },
    // },
    // {
    //   name: "price_basis",
    //   label: "Machine Translation Rate",
    //   options: {
    //     filter: false,
    //     customBodyRender: value =>
    //       getRateFromPriceBasis(value, "Machine Translation Editing (New)"),
    //   },
    // },
    {
      name: "price_list_id",
      label: "Copy Price",
      options: {
        sort: false,
        setCellHeaderProps: () => ({ style: { width: "200px" } }),
        setCellProps: () => ({ style: { width: "200px" } }),
        customBodyRender: (value, tableMeta) => {
          return (
            <div
              onClick={() => handleButtonClick(value)}
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                color: "#1976d2"
              }}
            >
              <ContentCopyIcon style={{ marginRight: 6 }} />
              Copy price list
            </div>
          );
        },
      },
    },


  ];

  const sortedData = SortAlphabetically(TableList || [], "price_name");
  const data = sortedData?.map((item, index) => ({
    rowNumber: index + 1,
    price_list_id: item.price_list_id,
    price_name: item.price_name,
  }));

  const handleEdit = rowData => {
    const selectedId = rowData[1];
    dispatch(GetOneClientPrice(selectedId));
    setEdited(true);
    setShow(true);
    setEdit(true);
  };

  const handleDeleteTable = id => {
    setOpenForDelete(true);
    setDeleteId(id);
  };
  const [selectedPriceId, setSelectedPriceId] = useState(null);

  const handleButtonClick = clickedId => {
    setSelectedPriceId(clickedId);
    setCopyOpen(true);
    setCopyToClient({});
  };

  const handleCopyPrice = () => {
    const payload = {
      price_list_id: selectedPriceId,
      externalUserClient: copyToClient.client_id,
      typeId: 2, // for freelancer resource 2 will be passed as static
    };
    dispatch(CopyToOtherUser(payload)).then(() => {
      setCopyOpen(false);
      setCopyToClient({});
    });
  };

  useEffect(() => {
    registerSubmit(handleSave);
  }, [formData]);

  useEffect(() => {
    if (freelancerCurrencyCode && !edit) {
      setFormData(prev => ({
        ...prev,
        price_currency: freelancerCurrencyCode,
      }));
    }
  }, [freelancerCurrencyCode, edit]);


  return (
    <Box sx={{ background: "#f4f4fb" }}>
      {show && (
        <Box sx={{ p: 1, mb: 4, borderRadius: 2 }} className="whiteBackground">
          <Grid container justifyContent="space-between" alignItems="flex-start">
            {/* Left Box - New Price List (Fixed Height) */}
            {/* <Grid item className="boxshadow" width="40%" p={2} sx={{ height: "150px" }}>
              <Typography variant="subtitle1">New price list</Typography>
              <Grid container justifyContent="space-between" alignItems="center" mt={1}>
                <Typography variant="subtitle1">Create new price list</Typography>
                <Btn onClick={() => setShow(prev => !prev)} disabled={edited === true}>
                  Create
                </Btn>
              </Grid>
            </Grid> */}

            {/* Right Box - Form Input (Flexible Height) */}
            {show && (
              <Grid item className="boxshadow" md={6} p={2} sx={{ height: "auto" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <TextFieldComponent
                      type="text"
                      name="price_name"
                      label="Name"
                      value={formData.price_name}
                      onChange={handleInputChange}
                      error={error.price_name}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <DropdownComponent
                      label="Currency Code"
                      name="price_currency"
                      value={formData.price_currency}
                      onChange={handleInputChange}
                      options={currencyOptions}
                      error={error.price_currency}
                      searchable={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextFieldComponent
                      type="text"
                      name="min_price_item"
                      label="Minimum Charge"
                      value={formData.min_price_item}
                      error={error.min_price_item}
                      onChange={handleInputChange}
                      isNotMandatory={true}
                      onlyNumber
                      fullWidth
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={12}>
                    <MultiSelect
                    label="Specialization"
                    name="specialization"
                    value={formData.specialization || []}
                    onChange={(e, name) => handleMultiSelectChange(e, name)}
                    handleChipDelete={handleChipDelete}
                    options={specializationOptions}
                  />
                  </Grid> */}
                </Grid>
              </Grid>
            )}

            {/* Languages Table */}
            {show && (
              <Grid item xs={12} md={6}>
                <DropdownWithSelectedList
                  label="Specialization"
                  name="specialization"
                  value={formData.specialization || []}
                  onChange={handleMultiSelectChange}
                  options={specializationOptions}
                  error={error.specialization}
                  required
                />
              </Grid>
            )}
          </Grid>

          {show && (
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={12} md={5}>
                <Box
                  sx={{
                    width: "100%",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    p: 2,
                    mt: 2,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ mb: 2 }}>
                    Languages
                  </Typography>
                  {error.languageRows && (
                    <Typography color="error" variant="caption" display="block" sx={{ mb: 1 }}>
                      {error.languageRows}
                    </Typography>
                  )}

                  <Table sx={{ borderBottom: "1px solid #ddd" }}>
                    <TableHead>
                      <TableRow sx={{ background: "#f8f8f8" }}>
                        <TableCell sx={{ fontWeight: "bold" }}>Languages</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {languageRows.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row}</TableCell>
                          <TableCell>
                            <IconButton onClick={() => handleDelete(index)} color="error">
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {/* Form to Add New Language Rows */}
                  <Box sx={{ mt: 3 }}>
                    <Grid container alignItems="center" spacing={3}>
                      <Grid item xs={12} container alignItems="center">
                        <Typography variant="body2" sx={{ width: "100%" }}>
                          Add Language Pair
                        </Typography>

                        {/* Source Language */}
                        <Grid item xs={4.5} p={0}>
                          <DropdownComponent
                            label="Source Language"
                            name="source_lang"
                            value={formData.source_lang}
                            onChange={e => handleChangeLanguage("source_lang", e.target.value)}
                            error={error.source_lang}
                            options={languageOptions}
                          />
                        </Grid>

                        {/* Target Language */}
                        <Grid item xs={4.5} p={2}>
                          <DropdownComponent
                            label="Target Language"
                            name="target_lang"
                            value={formData.target_lang}
                            error={error.target_lang}
                            onChange={e => handleChangeLanguage("target_lang", e.target.value)}
                            options={languageOptions}
                          />
                        </Grid>

                        {/* ✔ Button */}
                        <Grid item xs={2} mt={3} p={3}>
                          <Btn onClick={handleAddLanguageRow}>✔</Btn>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
              {/* Prices Table */}
              <Grid item xs={12} md={7}>
                <Box
                  sx={{
                    width: "100%",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    p: 2,
                    mt: 2,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ mb: 2 }}>
                    Prices
                  </Typography>
                  {error.priceRows && (
                    <Typography color="error" variant="caption" display="block" sx={{ mb: 1 }}>
                      {error.priceRows}
                    </Typography>
                  )}

                  <Table sx={{ width: "100%", borderBottom: "1px solid #ddd" }}>
                    <TableHead>
                      <TableRow sx={{ background: "#f8f8f8" }}>
                        <TableCell sx={{ fontWeight: "bold" }}>Quantity</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Price unit</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Prices</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Total</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {priceRows.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <TextField
                              type="text"
                              value={row.quantity}
                              onChange={e =>
                                isValidNumber(e.target.value) &&
                                handleQuantityChange(index, e.target.value)
                              }
                              fullWidth
                            />
                          </TableCell>
                          <TableCell>{row.priceUnit}</TableCell>
                          <TableCell>
                            <TextField
                              type="text"
                              value={row.prices}
                              onChange={e =>
                                isValidNumber(e.target.value) &&
                                handlePriceChange(index, e.target.value)
                              }
                              fullWidth
                            />
                          </TableCell>
                          <TableCell>{row.total} {freelancerCurrencyCode}</TableCell>
                          <TableCell>
                            <IconButton onClick={() => handleDeletePriceRow(index)} color="error">
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {/* Form to Add New Price Rows */}
                  <Box sx={{ mt: 3 }}>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid
                        item
                        xs={12}
                        container
                        alignItems="center"
                        // spacing={2}
                        wrap="nowrap"
                      >
                        <Typography variant="body2" sx={{ width: "100%" }}>
                          Add Price Details
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Autocomplete
                          multiple
                          options={options}
                          groupBy={option => (option.type === "master" ? option.name : "")}
                          getOptionLabel={option => option.name}
                          value={selectedPrices}
                          onChange={handleChange}
                          disableCloseOnSelect
                          renderInput={params => (
                            <TextField
                              {...params}
                              //   variant="outlined"
                              placeholder="Choose price(s)"
                              InputLabelProps={{ shrink: true }}
                              error={!!error.selectedPrices}
                              helperText={error.selectedPrices}
                            />
                          )}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              {...props}
                              sx={{
                                padding: "6px 16px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {option.type === "master" ? (
                                <Typography sx={{ fontWeight: "bold" }}>{option.name}</Typography>
                              ) : (
                                <Typography sx={{ paddingLeft: 3 }}>{option.name}</Typography>
                              )}
                            </Box>
                          )}
                          renderTags={(selected, getTagProps) =>
                            selected.map((option, index) => (
                              <Chip
                                {...getTagProps({ index })}
                                key={option.name}
                                label={option.name}
                                onDelete={() =>
                                  setSelectedPrices(selected.filter(s => s !== option))
                                }
                              />
                            ))
                          }
                        />
                      </Grid>
                      {/* OK Button */}
                      <Grid item xs={4}>
                        <Btn onClick={handleAddPriceRow}>OK</Btn>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          )}
          {show && (
            <Box sx={{ mt: 3, mb: 3, mr: 2, textAlign: "right" }}>
              <Btn onClick={handleSave}>Save</Btn>
            </Box>
          )}
        </Box>
      )}
      <Box mt={2} mb={2}>
        {/* <Btn onClick={() => setShow(prev => !prev)} disabled={edited === true}> */}
        <Btn
          onClick={() => {
            setShow(prev => {
              const next = !prev;

              if (!prev && freelancerCurrencyCode) {
                setEdit(false);
                setEdited(false);
                setFormData(prevData => ({
                  ...prevData,
                  price_currency: freelancerCurrencyCode, // ✅ RESET HERE
                }));
              }

              return next;
            });
          }}
          disabled={edited === true}
        >
          Create Price List
        </Btn>
      </Box>
      <Box className="whiteBackground" mt={4}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={11}>
            <GenericTable
              columns={columns}
              data={data}
              onEdit={handleEdit}
              onDelete={handleDeleteTable}
              displayColumns={4}
              displayRows={data?.length || 5}
            />
          </Grid>
        </Grid>
      </Box>
      {openForDelete && (
        <PopupModal
          maxWidth={"sm"}
          size={"sm"}
          fullWidth={true}
          open={openForDelete}
          handleClose={() => setOpenForDelete(false)}
          actions={
            <Grid container columnGap={2} justifyContent={"end"}>
              <Btn
                onClick={() =>
                  dispatch(DeleteClientPriceList(deleteId[1])).then(() => {
                    setFormData({
                      price_name: ``,
                      price_currency: "",
                      min_price_item: "",
                      specialization: [],
                      source_lang: "",
                      target_lang: "",
                      basePriceType: "",
                    });
                    setShow(false);
                    setEdited(false);
                    dispatch(CustomerPriceListing(2));
                    setOpenForDelete(false);
                  })
                }
              >
                Yes
              </Btn>
              <Btn onClick={() => setOpenForDelete(false)}>Cancel</Btn>
            </Grid>
          }
          title={<Typography variant="h6">Delete Price List</Typography>}
        >
          <Typography>Are you sure you want to delete the selected price list ?</Typography>
        </PopupModal>
      )}
      {copyOpen && (
        <PopupModal
          maxWidth={"sm"}
          size={"sm"}
          fullWidth={true}
          open={copyOpen}
          handleClose={() => setCopyOpen(false)}
          actions={
            <Grid container columnGap={2} justifyContent={"end"}>
              <Btn onClick={handleCopyPrice}>Copy</Btn>
              <Btn onClick={() => setCopyOpen(false)}>Cancel</Btn>
            </Grid>
          }
          title={<Typography variant="h6">Copy Price record to other Linguist</Typography>}
        >
          <Grid item xs={12} sm={12}>
            <DropdownComponent
              label="Select Option"
              name="client_id"
              value={copyToClient.client_id}
              onChange={handleInputChange}
              options={jobResourceOptions}
              searchable={true}
              isNotMandatory={true}
            />
          </Grid>
        </PopupModal>
      )}
    </Box>
  );
};

export default Step3;
